import React, { useState, useEffect } from "react";
import { navigate } from "gatsby";
import "./magazineSlider.scss";
import Slider from "react-slick";

import Button from "../../atoms/button/button";
import CardJournal from "../../atoms/card-journal/cardJournal";
import Loading from "../../atoms/loading/loading"

import { getFilteredResults } from "../../../services/filter";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

const MagazineSlider = (props: ReferenciaContenido) => {
  const [journals, setJournals] = useState<any[]>([]);
  const [LoadingBar, setLoadingBar] = useState(true)
  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();

  const goToNext = () => {
    slider.slickGoTo(sliderIndex + 4);
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - 4);
  };

  const isActiveNext = (_true: any, _false: any) => {
    return sliderIndex < journals?.length - 4 ? _true : _false;
  };

  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
    responsive: [
      {
        breakpoint: 960,
        settings: {
          centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      }
    ],
  };

  const seeAll = () => {
    const collection = props.etiquetasArticulo ? props.etiquetasArticulo[0] : "";
    navigate(`/ver-todo/?title=${props.tituloGeneral}` +
    `&searchType=filter` +
    `&contentType=Revistas` + 
    `&searchParam=word,contentType` +
    `&paramValues=/-${"journal digital"}/-${""}/-${collection}/-DATE`,
     {
      state: {},
    });
  };

  const getJournal = async () => {
    const collection = props.etiquetasArticulo ? props.etiquetasArticulo[0] : "";
    const booksReq = await getFilteredResults(
      "",
      props.tipoLibro || "",
      "12",
      "",
      collection,
      "DATE"
    );
    setJournals(booksReq?.data.data.filter);
    setLoadingBar(false)
  };

  useEffect(() => {
    getJournal();
  }, []);

  return (
    <section className="m-magazine-slider">
      <div className="m-magazine-slider__upper">
        <h2 className="m-magazine-slider__upper-title">
          {props.tituloGeneral}
        </h2>
        <Button
          type="button"
          classname={`m-magazine-slider__upper-button 
            ${
              !journals || journals.length < 12
                ? "m-magazine-slider__upper-button--hide"
                : ""
            }`}
          text={props.tituloBoton}
          isDisabled={false}
          onClickAction={seeAll}
          gtmMark={`gtm${normalizeTwoWords(
            props.nombreCategoria
          )}${normalizeTwoWords(props.tituloGeneral)}${normalizeTwoWords(
            props.tituloBoton
          )}`}
        />
      </div>
      {LoadingBar ? <Loading/> : 
        <div>
        <div className="m-magazine-slider__shadow"></div>
        <Slider ref={(_slider) => setSlider(_slider)} {...settings}>
          {journals?.map((journal, idx) => (
            <CardJournal journal={journal} gtmClass={""} key={idx} />
          ))}
        </Slider>
        {journals?.length > 4 && (
          <>
            <div
              className="arrow-content arrow-content__left"
              onClick={isActiveBack(goToBack, undefined)}
            >
              <div className="arrows">
                <div className="arrows-contain">
                  <div
                    className={isActiveBack(
                      "arrow icon-chevron-left active",
                      "arrow icon-chevron-left"
                    )}
                  />
                </div>
              </div>
            </div>
            <div
              className="arrow-content arrow-content__right"
              onClick={isActiveNext(goToNext, undefined)}
            >
              <div className="arrows">
                <div className="arrows-contain">
                  <div
                    className={isActiveNext(
                      "arrow icon-chevron-right active",
                      "arrow icon-chevron-right"
                    )}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      }
      
    </section>
  );
};

export default MagazineSlider;
